<template>
    <div class="shopify-warm-welcome-wrapper">
        <img src="images/jasper-shopify.png" alt="Jasper and Shopify logos" class="logo" />
        <h1>Welcome To Your PIM Solution</h1>
        <div class="text-left pt-4">
            <p>We are excited to help get you started on the #1 Product Information Management solution to grow your online business. Over on the left-hand navigation are the menus to start building your products, create attributes to add unique detail to your catalog, and set up your channels to help connect with your ecommerce store to run an import and expand to various marketplaces.</p>
            <p>Remember, we are the PIM that helps you sell more by reaching out to new customers quickly, save time and money, and merchandise products better than before!</p>

            <div class="feature-nav">
                <button
                    type="button"
                    class="btn"
                    :class="tabClass('product')"
                    @click="tabSwitch('product')"
                >Adding Products</button>
                <button
                    type="button"
                    class="btn"
                    :class="tabClass('attribute')"
                    @click="tabSwitch('attribute')"
                >Adding Attributes</button>
                <button
                    type="button"
                    class="btn"
                    :class="tabClass('channel')"
                    @click="tabSwitch('channel')"
                >Adding Channels</button>
                <button
                    type="button"
                    class="btn"
                    :class="tabClass('support')"
                    @click="tabSwitch('support')"
                >Getting Support</button>

            </div>

            <div class="feature-blocks">
                <transition name="fade">
                    <div class="product-feature" v-if="activeFeature == 'product'">
                        <div class="feature-desc">
                            <h4>Adding products to your PIM</h4>
                            <p>The Jasper PIM supports many product workflows including the ability to create and publish products wholly within the PIM itself.</p>
                            <ol>
                                <li>Click <strong>Products</strong> in the side menu</li>
                                <li>Click the <strong>Create Product</strong> button</li>
                            </ol>
                        </div>
                        <div>
                            <img
                                src="images/warm-welcome/warm-welcome-products.png"
                                alt="Jasper and Shopify logos"
                            />
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="product-feature" v-if="activeFeature == 'attribute'">
                        <div class="feature-desc">
                            <h4>Adding Attributes to your PIM</h4>
                            <p>Attributes are flexible fields that can be used to power faceted search applications, organize data for internal use, or display specialized assets on product detail pages. They are a place to store all your custom data points.</p>
                            <ol>
                                <li>Click <strong>Configuration</strong> in the side menu</li>
                                <li>Click <strong>Attributes</strong> in the submenu</li>
                                <li>Click <strong>Attributes</strong> in the submenu</li>
                                <li>Click the <strong>Create Attribute</strong> button</li>
                            </ol>
                        </div>
                        <div>
                            <img
                                src="images/warm-welcome/warm-welcome-attributes.png"
                                alt="Jasper and Shopify logos"
                            />
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="product-feature" v-if="activeFeature == 'channel'">
                        <div class="feature-desc">
                            <h4>Adding Channels to your PIM</h4>
                            <p>Storing and managing your product information in the PIM is only part of the benefits of using Jasper PIM. Our self-serve Channel Configuration tool gives you the ability to add new BigCommerce, Shopify, or Magento M2 Storefronts quickly and easily</p>
                            <ol>
                                <li>Click <strong>Configuration</strong> in the side menu</li>
                                <li>Click <strong>Channels</strong> in the submenu</li>
                                <li>Click the <strong>Create Channel</strong> button</li>
                            </ol>
                        </div>
                        <div>
                            <img
                                src="images/warm-welcome/warm-welcome-channels.png"
                                alt="Jasper and Shopify logos"
                            />
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <div class="product-feature" v-if="activeFeature == 'support'">
                        <div class="feature-desc">
                            <h4>Getting Support</h4>
                            <p>Don't forget you can always access our well detailed Knowledge Base Help Centre. You can also contact our support team by submitting a ticket for any inqueries you may have.</p>
                            <ol>
                                <li>Click <strong>Help Centre</strong> in the side menu</li>
                            </ol>
                        </div>
                        <div>
                            <img
                                src="images/warm-welcome/warm-welcome-support.png"
                                alt="Jasper and Shopify logos"
                            />
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('dismiss', notification)"
        ><span class="fa fa-close pr-2"></span>Close Welcome Message</button>

    </div>
</template>

<script>
export default {
    name: "shopify-warm-welcome",
    props: {
        notification: Object
    },
    data() {
        return {
            activeFeature: "product"
        };
    },
    methods: {
        tabSwitch(feature) {
            this.activeFeature = feature;
        },
        tabClass(feature) {
            if (feature === this.activeFeature) {
                return "btn-primary";
            }
            return "btn-secondary";
        }
    }
};
</script>

<style scoped>
h1 {
    font-weight: 100;
    padding-top: 1.5rem;
}

img {
    width: 60em;
}

.logo {
    width: 40em;
}

.product-feature {
    position: absolute;
    background-color: white;
    margin-top: 20px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-color: silver;
    border-style: solid;
    border-width: 1px;
}

.feature-desc {
    padding-right: 20px;
    min-width: 200px;
}

.feature-nav {
    display: flex;
    justify-content: center;
}

.feature-blocks {
    position: relative;
    min-height: 480px;
}

button {
    margin: 3px;
}

ol {
    padding-left: 1em;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.75s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>